import React from 'react';
import PropTypes from "prop-types";
import './tooltip.css';

const Tooltip = React.forwardRef(
  (
    { 
      children, 
      arrowPosition = '', 
      colorClass = '', 
      className = '', 
      ...restProps 
    },
    ref,
  ) => {
  return (
    <>
      <div 
        ref={ref}
        className={`tooltip tooltip-arrow ${arrowPosition} ${colorClass} ${className}`} {...restProps}
      >
        {children}
      </div>
    </>
  );
});

Tooltip.propTypes = {
  arrowPosition: PropTypes.string,
  colorClass: PropTypes.string,
  className: PropTypes.string
};

export { Tooltip };
